// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetContext, ActionSheetV2, Body, Button, LgPadding } from '@alto/design-system';
import React, { useContext } from 'react';
import { IMG_ALT_TEXTS, ORGANIC_ONBOARDING_STEPS } from '~shared/constants';
import { getCurrentUser } from '~shared/features/users/selectors/getCurrentUser';
import { useSelectorShared } from '~shared/store';
import {
  OnboardingCommsPreferencesActionSheet,
  OnboardingMedicalInfoActionSheet,
  getOrganicOnboardingStep,
} from './OrganicOnboarding';
import { Image } from '~web/components/Image';
import prescriptions from '~web/images/prescriptions@2x.png';

export const OnboardingResumeActionSheet = () => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const currentUser = useSelectorShared(getCurrentUser);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const currentStep = getOrganicOnboardingStep(currentUser!);
  const handleContinueOnboarding = () => {
    if (currentStep === ORGANIC_ONBOARDING_STEPS.COMMUNICATION_PREFERENCES) {
      setActiveActionSheet(<OnboardingCommsPreferencesActionSheet />, { dismissible: false });
    } else {
      setActiveActionSheet(<OnboardingMedicalInfoActionSheet />, { dismissible: false });
    }
  };
  const message =
    currentStep === ORGANIC_ONBOARDING_STEPS.HEALTH_PROFILE
      ? 'Let’s finish filling out your medical info so we can get your medications delivered ASAP.'
      : 'Set your communication preferences so we can get your medications delivered ASAP';

  return (
    <ActionSheetV2
      title="Welcome back!"
      analyticsName="organic_onboarding_resume"
      dismissible={false}
      buttons={[
        <Button
          key="resume-onboarding-button"
          label="Okay!"
          accessibilityLabel="Press to continue onboarding"
          onPress={handleContinueOnboarding}
        />,
      ]}
    >
      <LgPadding
        topPadding={SPACING.STATIC.NONE}
        bottomPadding={SPACING.STATIC.NONE}
      >
        <Body>{message}</Body>
        <Image
          center
          src={prescriptions}
          alt={IMG_ALT_TEXTS.prescriptions}
        />
      </LgPadding>
    </ActionSheetV2>
  );
};
